export default __webpack_public_path__ + "static/media/FSM_updated.1c0696f4.png";